import Backdrop from '@material-ui/core/Backdrop';
import Fade from '@material-ui/core/Fade';
import Modal from '@material-ui/core/Modal';
import React from 'react';
import { useAppSelector } from '../../../store';

const DeleteWarningModal = (props: any) => {
    const { words } = useAppSelector(state => state.localization);

    const handleClose = () => {
        props.setOpen(false);
    };

    return (
        <Modal
            aria-labelledby="transition-modal-title"
            aria-describedby="transition-modal-description"
            className="modal-14"
            open={props.open}
            closeAfterTransition
            BackdropComponent={Backdrop}
            BackdropProps={{
                timeout: 500,
            }}
            onClose={handleClose}>
            <Fade in={props.open}>
                <div className="modal-content">
                  <img className='c-item-01' src='https://khicindekocvar.blob.core.windows.net/prod/logout2.png'/>
                    <p className="c-item-02">{props.message}</p>
                    <button className='c-item-03' onClick={handleClose}>{words && words['WEB.ok']}</button>
                </div>
            </Fade>
        </Modal>
    );
};

export default DeleteWarningModal;
